import * as data from '../mapStyles.json';
import locIcon from '../../img/loc-icon.svg';
import activeLocIcon from '../../img/loc-icon--active.svg';

export default class GoogleMap {
  constructor() {
    this.mapElement = document.querySelector('.map');
    this.map;
    this.markers = [];
    this.activeMarkers = [];
    this.markerImg = null;

    this.searchInput;
    this.searchBox;

    //range in km
    this.searchRange = 50;
    this.offset = 1.5;

    this.minZoom = 6;

    this.shopElems = document.querySelectorAll('.place');
    this.countryElems = document.querySelectorAll(
      '.verkooppunten-zoeker__locations .fold-content__header'
    );

    this.countryDropdownsPlaces = document.querySelectorAll(
      '.verkooppunten-zoeker__places'
    );

    this.countryDropdowns = document.querySelectorAll(
      '.verkooppunten-zoeker__locations .fold-content'
    );

    if (this.mapElement) {
      this.mapData = JSON.parse(this.mapElement.getAttribute('data-mapData'));
      this.searchInput = document.querySelector('#mapSearch');

      this.setOffset();
      this.initMap();

      window.addEventListener('resize', () => {
        this.setOffset();
      });
    }
  }

  setOffset() {
    if (window.innerWidth > 800) {
      this.offset = 1.5;
    } else {
      this.offset = 0;
    }
  }

  addListenersToshops() {
    this.shopElems.forEach((shop) => {
      shop.addEventListener('click', (e) => this.handleCLickShop(e));
    });

    this.countryElems.forEach((countryElem) => {
      countryElem.addEventListener('click', (e) => this.handleClickCountry(e));
    });
  }

  handleClickCountry(e) {
    const elem = e.currentTarget;
    const lat = parseFloat(elem.dataset.lat);
    const lng = parseFloat(elem.dataset.lng) + this.offset;

    this.map.setCenter({ lat, lng });
    this.map.setZoom(6);

    //close other parents
    this.countryElems.forEach((countryElem) => {
      if (elem !== countryElem) {
        countryElem.parentElement.classList.remove('open');

        countryElem.parentElement.querySelector(
          '.fold-content__content-wrapper'
        ).style.maxHeight = '';
      }
    });

    setTimeout(() => {
      this.activateMarker();
    }, 100);
  }

  handleCLickShop(e) {
    const id = parseInt(e.currentTarget.dataset.id);

    //find the marker with this id
    const marker = this.markers.find((marker) => marker.id === id);

    if (marker) {
      //update color
      this.activateMarker(marker.id, true);

      this.map.setCenter(
        new google.maps.LatLng(
          marker.markerElem.position.lat,
          marker.markerElem.position.lng + this.offset / 2
        )
      );
      this.map.setZoom(9);
    }

    this.scrollToMap();
  }

  async initMap() {
    this.markers = [];
    this.activeMarkers = [];
    this.markerImg = document.createElement('img');

    this.markerImg.src = locIcon;

    const settings = {
      center: { lat: 50.595437253569706, lng: 8.050501129481898 },
      mapId: '8c150e56fdf305d3',
      styles: data,
    };

    // Request needed libraries.
    const { Map } = await google.maps.importLibrary('maps');

    this.searchBox = new google.maps.places.SearchBox(this.searchInput);
    this.searchInput.placeholder = '';

    this.searchBox.addListener('places_changed', () => {
      this.handleChangePlace();
    });

    this.searchInput.addEventListener('input', () => {
      this.handleChangePlace();
    });

    // The map
    this.map = new Map(this.mapElement, settings);

    //add markers
    this.setupMarkers();

    //setup listeners
    this.addListenersToshops();
  }

  async setupMarkers() {
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
    const bounds = new google.maps.LatLngBounds();

    Object.keys(this.mapData).forEach((markerKey) => {
      this.mapData[markerKey].forEach((marker) => {
        const lat = parseFloat(marker.fields.adress.lat);
        const lng = parseFloat(marker.fields.adress.lng);

        if (lat && lng) {
          const icon = document.createElement('img');
          icon.alt = marker.title;
          icon.src = locIcon;

          const markerElem = new AdvancedMarkerElement({
            map: this.map,
            position: {
              lat: lat,
              lng: lng,
            },
            title: marker.title,
            content: icon,
          });

          markerElem.content.classList.add(`map-marker`);
          markerElem.content.classList.add(`map-marker-${marker.id}`);
          markerElem.content.classList.add(`active`);

          //add listener
          markerElem.addListener('click', (e) =>
            this.handleClickMarker(e, {
              id: marker.id,
              markerElem,
            })
          );

          this.markers.push({
            id: marker.id,
            markerElem,
          });

          /* Set marker to bounds */
          bounds.extend(markerElem.position);
        }
      });
    });

    //set init active markers
    this.activeMarkers = this.markers;

    //auto bounds
    //this.map.fitBounds(bounds);

    //set max zoom
    this.map.setZoom(this.minZoom);
  }

  scrollToMap() {
    if (window.innerWidth < 800) {
      //scroll to map
      this.mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  activateMarker(id = false, highlight = false) {
    const markers = document.querySelectorAll('.map-marker');

    markers.forEach((marker) => {
      if (marker.classList.contains(`map-marker-${id}`) || !id) {
        //set as active
        marker.classList.add('active');
        if (highlight) {
          marker.classList.add('highlighted');
        } else {
          marker.classList.remove('highlighted');
        }
      } else {
        //set as inactive
        marker.classList.remove('active');
        marker.classList.remove('highlighted');
      }
    });

    this.setActivePlace(id);
  }

  setMarkerVisibility(id, visibility) {
    const marker = document.querySelector(`.map-marker-${id}`);

    if (marker) {
      if (visibility) {
        marker.classList.add('active');
      } else {
        marker.classList.remove('active');
        marker.classList.remove('highlighted');
      }
    }
  }

  handleChangePlace() {
    const places = this.searchBox.getPlaces();

    this.activateMarker();

    if (places && this.searchInput.value !== '') {
      const location = [
        places[0].geometry.location.lat(),
        places[0].geometry.location.lng(),
      ];
      const bounds = new google.maps.LatLngBounds();

      //got to location on map

      //reset active markers
      this.activeMarkers = [];

      //set active markers
      this.markers.forEach((marker) => {
        if (
          this.calcCrow(
            location[0],
            location[1],
            marker.markerElem.position.lat,
            marker.markerElem.position.lng
          ) <= this.searchRange
        ) {
          //is in range
          this.activeMarkers.push(marker);

          /* Set marker to bounds */
          bounds.extend(marker.markerElem.position);

          //filter shops
          this.filtershop(marker.id, true);

          //show marker
          this.setMarkerVisibility(marker.id, true);
        } else {
          this.filtershop(marker.id, false);

          //hide marker
          this.setMarkerVisibility(marker.id, false);
        }
      });

      //auto zoom
      if (this.activeMarkers.length) {
        this.map.fitBounds(bounds);
      } else {
        //move to center
        this.map.setCenter({ lat: location[0], lng: location[1] });

        if (this.map.getZoom() > this.minZoom) {
          this.map.setZoom(this.minZoom);
        }
      }

      //set min zoom
    } else {
      //no places so reset all
      this.resetAll();
    }
  }

  calcCrow(lat1, lon1, lat2, lon2) {
    var R = 6371; // km
    var dLat = this.toRad(lat2 - lat1);
    var dLon = this.toRad(lon2 - lon1);
    var lat1 = this.toRad(lat1);
    var lat2 = this.toRad(lat2);

    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }

  // Converts numeric degrees to radians
  toRad(Value) {
    return (Value * Math.PI) / 180;
  }

  setActivePlace(id = false) {
    const places = document.querySelectorAll('.place');

    places.forEach((place) => {
      if (parseInt(place.dataset.id) === id || !id) {
        place.classList.remove('inActive');
      } else {
        place.classList.add('inActive');
      }
    });
  }

  handleClickMarker(e, marker) {
    const card = document.querySelector(`[data-id="${marker.id}"]`);

    this.activateMarker(marker.id, true);

    this.countryDropdowns.forEach((fold) => {
      fold.classList.remove('open');
    });

    this.map.setCenter(
      new google.maps.LatLng(
        marker.markerElem.position.lat,
        marker.markerElem.position.lng + this.offset / 2
      )
    );
    this.map.setZoom(9);

    card.parentElement.parentElement.parentElement.parentElement.classList.add(
      'open'
    );

    card.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  }

  filtershop(id, visible) {
    this.shopElems.forEach((shop) => {
      if (parseInt(shop.dataset.id) === id) {
        if (visible) {
          shop.classList.remove('hide');
        } else {
          shop.classList.add('hide');
        }
      }
    });

    //check if parent has children
    this.countryDropdownsPlaces.forEach((dropdown) => {
      const foldContent = dropdown.parentElement.parentElement.parentElement;
      if (
        Array.from(dropdown.children).filter(
          (child) => !child.classList.contains('hide')
        ).length
      ) {
        //has visible children
        foldContent.classList.remove('hide');
      } else {
        //no children
        foldContent.classList.add('hide');
      }
    });
  }

  resetAll() {
    this.activeMarkers = this.markers;

    this.activeMarkers.forEach((marker) => {
      this.filtershop(marker.id, true);
    });
  }
}
